export default __webpack_public_path__ + "static/knit2-aaece79a827af51f53d841a918f920a9.jpg";